import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class WeightService {
  private apiUrl = '/weights';
  private apiSpringUrl = '/spring/weights';

  constructor(private http: HttpService) { }

  get(carrierCd?: string): Promise<any> {
    let url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl;
    if (carrierCd) url += "?carrierCd=" + carrierCd;
    return this.http.get(url);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/weight/weight.service.ts